export const AUDIENCES = [
  "Grand public", "Entreprises", "Professionnels", "Étudiants",
  "Familles", "Associations", "Collectivités", "Autre",
];

export const APP_TYPES = [
  "Application mobile", "Application Web", "Mobile + Web", "Je ne sais pas encore",
];

export const CATEGORIES = [
  "Réseaux sociaux", "Business", "Services", "Vie quotidienne", "Voyage",
  "Mobilité", "Sport", "Santé et bien-être", "Éducation", "Environnement",
  "Finance", "Commerce", "Loisirs", "Intelligence artificielle", "Autre",
];

export const ADVANCEMENT = [
  "J'ai seulement l'idée",
  "J'ai commencé à réfléchir au fonctionnement",
  "J'ai déjà choisi un nom",
  "J'ai déjà un logo",
  "J'ai déjà réalisé des maquettes",
  "J'ai déjà un prototype",
  "J'ai déjà commencé un développement",
  "Autre",
];

export const GALLERY_FILTERS = [
  "Tous", "Mobile", "Web", "Business", "Social", "Services",
  "Innovation", "Loisirs", "Santé", "Éducation", "Mobilité", "Autres",
];

export const STATUSES = [
  "BROUILLON", "IDÉE DÉPOSÉE", "RETENU PAR NOS ÉQUIPES", "NON RETENU PAR NOS ÉQUIPES", "EN ÉTUDE", "PRÉSÉLECTIONNÉE", "FINALISTE",
  "SÉLECTIONNÉE", "EN CONCEPTION", "EN DESIGN", "EN DÉVELOPPEMENT",
  "EN TEST", "APPLICATION TERMINÉE",
];

// Étapes « gagnantes » (projet sélectionné et au-delà) — par nom, jamais par position.
export const WIN_STAGES = ["SÉLECTIONNÉE", "EN CONCEPTION", "EN DESIGN", "EN DÉVELOPPEMENT", "EN TEST", "APPLICATION TERMINÉE"];

export const STATUS_DESC = {
  "BROUILLON": "Votre dossier est enregistré comme brouillon.",
  "IDÉE DÉPOSÉE": "Votre projet a été enregistré.",
  "RETENU PAR NOS ÉQUIPES": "Bonne nouvelle : votre projet a été retenu par nos équipes.",
  "NON RETENU PAR NOS ÉQUIPES": "Votre projet n'a pas été retenu par nos équipes cette fois-ci.",
  "EN ÉTUDE": "L'équipe APP CHALLENGE ACADEMY analyse votre proposition.",
  "PRÉSÉLECTIONNÉE": "Votre projet a franchi une première étape.",
  "FINALISTE": "Votre projet fait partie des projets susceptibles d'être sélectionnés.",
  "SÉLECTIONNÉE": "Votre application a été choisie.",
  "EN CONCEPTION": "L'Academy travaille sur le fonctionnement et l'expérience.",
  "EN DESIGN": "Création des interfaces.",
  "EN DÉVELOPPEMENT": "L'application est en cours de programmation.",
  "EN TEST": "Tests et corrections.",
  "APPLICATION TERMINÉE": "Le projet est finalisé.",
};

export const PRIORITIES = ["Urgente", "Haute", "Moyenne", "Basse"];

// Noms de langues en français (affichage « langue du client » dans l'admin).
export const LANG_NAMES = {
  fr: "Français", en: "Anglais", es: "Espagnol", de: "Allemand", it: "Italien",
  pt: "Portugais", nl: "Néerlandais", ar: "Arabe", zh: "Chinois", ja: "Japonais",
  ko: "Coréen", ru: "Russe", tr: "Turc", pl: "Polonais", ro: "Roumain",
  el: "Grec", hi: "Hindi", id: "Indonésien", vi: "Vietnamien", th: "Thaï",
  sv: "Suédois", no: "Norvégien", da: "Danois", fi: "Finnois", uk: "Ukrainien",
  he: "Hébreu", fa: "Persan", sw: "Swahili",
};
export const langName = (code) => LANG_NAMES[(code || "").toLowerCase()] || (code ? code.toUpperCase() : "");

export const PRIORITY_STYLE = {
  "Urgente": "text-void border-cyan bg-cyan",
  "Haute": "text-electric border-electric/50 bg-electric/10",
  "Moyenne": "text-ink-secondary border-white/20 bg-white/5",
  "Basse": "text-ink-tertiary border-white/10 bg-white/5",
};

export const COUNTRIES = [
  "France",
  "Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre",
  "Angola", "Antigua-et-Barbuda", "Arabie saoudite", "Argentine", "Arménie",
  "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh",
  "Barbade", "Belgique", "Belize", "Bénin", "Bhoutan", "Biélorussie", "Birmanie",
  "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil", "Brunei", "Bulgarie",
  "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada", "Cap-Vert",
  "Chili", "Chine", "Chypre", "Colombie", "Comores", "Congo", "Congo (RDC)",
  "Corée du Nord", "Corée du Sud", "Costa Rica", "Côte d'Ivoire", "Croatie",
  "Cuba", "Danemark", "Djibouti", "Dominique", "Égypte", "Émirats arabes unis",
  "Équateur", "Érythrée", "Espagne", "Estonie", "Eswatini", "États-Unis",
  "Éthiopie", "Fidji", "Finlande", "Gabon", "Gambie", "Géorgie", "Ghana",
  "Grèce", "Grenade", "Guatemala", "Guinée", "Guinée équatoriale",
  "Guinée-Bissau", "Guyana", "Haïti", "Honduras", "Hongrie", "Îles Marshall",
  "Îles Salomon", "Inde", "Indonésie", "Irak", "Iran", "Irlande", "Islande",
  "Israël", "Italie", "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya",
  "Kirghizistan", "Kiribati", "Koweït", "Laos", "Lesotho", "Lettonie", "Liban",
  "Liberia", "Libye", "Liechtenstein", "Lituanie", "Luxembourg",
  "Macédoine du Nord", "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali",
  "Malte", "Maroc", "Maurice", "Mauritanie", "Mexique", "Micronésie", "Moldavie",
  "Monaco", "Mongolie", "Monténégro", "Mozambique", "Namibie", "Nauru", "Népal",
  "Nicaragua", "Niger", "Nigeria", "Norvège", "Nouvelle-Zélande", "Oman",
  "Ouganda", "Ouzbékistan", "Pakistan", "Palaos", "Palestine", "Panama",
  "Papouasie-Nouvelle-Guinée", "Paraguay", "Pays-Bas", "Pérou", "Philippines",
  "Pologne", "Portugal", "Qatar", "République centrafricaine",
  "République dominicaine", "République tchèque", "Roumanie", "Royaume-Uni",
  "Russie", "Rwanda", "Saint-Christophe-et-Niévès", "Saint-Marin",
  "Saint-Vincent-et-les-Grenadines", "Sainte-Lucie", "Salvador", "Samoa",
  "Sao Tomé-et-Principe", "Sénégal", "Serbie", "Seychelles", "Sierra Leone",
  "Singapour", "Slovaquie", "Slovénie", "Somalie", "Soudan", "Soudan du Sud",
  "Sri Lanka", "Suède", "Suisse", "Suriname", "Syrie", "Tadjikistan", "Tanzanie",
  "Tchad", "Thaïlande", "Timor oriental", "Togo", "Tonga", "Trinité-et-Tobago",
  "Tunisie", "Turkménistan", "Turquie", "Tuvalu", "Ukraine", "Uruguay",
  "Vanuatu", "Vatican", "Venezuela", "Viêt Nam", "Yémen", "Zambie", "Zimbabwe",
  "Autre",
];
